import { FieldLabel } from "@cleanbudget/ui/components/field";
import type { ComponentProps } from "react";
import { HelpButton } from "./help-button";
import type { HelpTopicId } from "./topics";

/**
 * A field's label with the field's (?) beside it (spec admin-help, "De (?) en de controle"): for a
 * field that needs explaining (a term from CONTEXT.md, or what touches the price, the stock or the
 * shop). Without `help`, the label alone. The field's grey line under it stays.
 */
export function HelpLabel({ help, ...label }: ComponentProps<typeof FieldLabel> & { help?: HelpTopicId }) {
	if (!help) return <FieldLabel {...label} />;
	return (
		<div className="flex items-center gap-1">
			<FieldLabel {...label} />
			<HelpButton topic={help} />
		</div>
	);
}
